import React from 'react'
import { Routes, Route } from 'react-router-dom'
import LoginRuoYiRedirect from './LoginRuoYiRedirect'
import Register from './Register'
import ForgotPassword from './ForgotPassword'

const Auth: React.FC = () => {
  return (
    <Routes>
      <Route path="login" element={<LoginRuoYiRedirect />} />
      <Route path="register" element={<Register />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
    </Routes>
  )
}

export default Auth

